// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"243":"57a21c94","317":"b8a480a8"}[chunkId] + ".chunk.js";
};